import React, { useRef } from 'react';
import classNames from 'classnames';
import createDecorator from 'final-form-focus';
import { Form } from 'react-final-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import FormField from '@ui/formfield/FormField';
import api from '@utils/api';
import customEventBus from '@common/scripts/libs/eventBus';
import { removeChatInfosFromStorage } from '@components/chat/ChatUtils';
import ErrorBox from '@components/common/ErrorBox';
import analytics from '@stone/utils/analytics';
import Button from '@stone/ui/button/Button';
import LoginEditEmail from './LoginEditEmail';
import { siteUrl } from '@common/utils/urlutils';
import { getRandomUUID } from '@common/utils/stringUtils';
import { useLangChecker } from '@common/utils/i18n';
const focusOnError = createDecorator(); // must be outside the component
const LoginPasswordForm = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = React.useState([]);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).loginButton;
    const redirectAfterSuccess = new URLSearchParams(window.location.search).get('redirectToPdp');
    const onSubmit = async (values) => {
        setErrors([]);
        setIsSubmitting(true);
        values.loginEmail = props.loginEmail;
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        props.onBeforeRequest && props.onBeforeRequest(values);
        api
            .login(values, redirectAfterSuccess)
            .then((data) => {
            if (data.success) {
                analytics.loginOrRegister('email', 'logged');
                (props === null || props === void 0 ? void 0 : props.updateLoggeedStatus) && (props === null || props === void 0 ? void 0 : props.updateLoggeedStatus(data.authenticatedCustomer));
                removeChatInfosFromStorage();
                if (props === null || props === void 0 ? void 0 : props.linkreload) {
                    window.location.href = props.linkreload;
                }
                else if (props.reloadComponent) {
                    window.loggedin = true;
                    customEventBus.emit('account:update', { customerName: data.authenticatedCustomer });
                }
                else {
                    window.location.reload();
                }
            }
            if (data.error && data.error.length > 0) {
                if (data.error[0] == 'migration') {
                    window.location.href = siteUrl('forgotpasswordform', 'migration', true);
                }
                else {
                    setErrors(data.error);
                    setIsSubmitting(false);
                }
            }
        })
            .catch((e) => {
            setErrors([e]);
            setIsSubmitting(false);
        });
    };
    const raondmSuffix = getRandomUUID();
    return (React.createElement(React.Fragment, null,
        !props.formOnly && (React.createElement("div", { className: "row" },
            props.heading && React.createElement("div", { className: "col" }, props.heading),
            React.createElement(LoginEditEmail, { emailOnly: props.emailOnly, loginEmail: props.loginEmail, singleColumn: props.singleColumn, onClick: props.setLoginStep && (() => props.setLoginStep('email')) }))),
        React.createElement(Form, { onSubmit: onSubmit, decorators: [focusOnError], render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit, className: classNames({ 'mt-40': props.singleColumn }) },
                React.createElement("div", { className: classNames('formfields password-form', { 'has-password-error': errors.length >= 1 }) },
                    React.createElement(FormField, { name: "loginPassword", idSuffix: raondmSuffix, label: t('label.password'), type: "password", autocomplete: "current-password", showPassword: true, required: true }),
                    React.createElement("div", { className: "forgot-pw-error" },
                        React.createElement("div", { className: "forgot-pw-error__pw" },
                            React.createElement("a", { className: "button forgot-pw button--link-underline", href: siteUrl('forgotpasswordform') }, t('login.forgottenpassword'))),
                        React.createElement("div", { className: "forgot-pw-error__error" },
                            React.createElement(ErrorBox, { errors: errors }))),
                    !window.clickfromstore && (React.createElement("div", { className: "remember-me" },
                        (props.rememberme && React.createElement(FormField, { idSuffix: raondmSuffix, name: "loginRememberMe", label: t('label.rememberme'), type: "checkbox", checked: true })) || (React.createElement("div", { className: "remember-me-empty" })),
                        React.createElement("a", { href: siteUrl('privacy'), target: "_blank", rel: "noreferrer", className: "privacy-link font__title", ref: useLangChecker }, t('login.privacypolicy'))))),
                showRecaptcha && createPortal(React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }), document.body),
                React.createElement("div", { className: "mt-40" },
                    React.createElement(Button, { type: "submit", disabled: isSubmitting, cls: ['button--primary'], className: "full" }, t('login.toyouraccount'))))) })));
};
export default LoginPasswordForm;
